import "../../../styles/Pages/Produits/Veilleuses/dino.css";
import { useState, useEffect, useRef } from "react";
import { db } from "../../../Firebase/firebase-config";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { addProductToPanier } from "../../../Firebase/panier";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";
import ProductComponent from "../../../Composants/Product/ProductComponent";
import { useFlyToCart } from "../../../hooks/useFlyToCart";
import { useToast } from "../../../context/ToastContext";
import { useCartCount } from "../../../context/CartContext";
import FirstDino from "../../../assets/Pages/Produits/Veilleuses/Dino/FirstDino.png";
import vertynoLogo from "../../../assets/Pages/Produits/Veilleuses/Dino/vertynoLogo.png";
import dinoBack from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoBack.png";
import oeufdino from "../../../assets/Pages/Produits/Veilleuses/Dino/oeufdino.png";
import dinoOne from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoOne.png";
import dinoTwo from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoTwo.png";
import dinoGround from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoGround.png";
import dinoThree from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoThree.png";
import dinoQuatre from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoQuatre.png";
import dinoFive from "../../../assets/Pages/Produits/Veilleuses/Dino/dinoFive.png";
import imgFicheDino from "../../../assets/Pages/Produits/Veilleuses/Dino/imgFicheDino.png";

// 🔹 Fonction pour ajouter l'email à Brevo
async function addEmailToBrevo(email) {
  try {
    await axios.post(
      "https://api.brevo.com/v3/contacts",
      {
        email: email,
        updateEnabled: true,
      },
      {
        headers: {
          "api-key": process.env.REACT_APP_BREVO_API_KEY,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Email ajouté à Brevo !");
  } catch (error) {
    console.error("Erreur ajout Brevo :", error.response?.data || error);
    throw error;
  }
}

export default function DinoLedinosaure() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [ficheQuantity, setFicheQuantity] = useState(1);
  
  // Refs pour les boutons "Commander" (pour l'animation)
  const heroButtonRef = useRef(null);
  const ficheCtaRef = useRef(null);
  const packagingButtonRef = useRef(null);
  
  // Hook pour l'animation de vol vers le panier
  const flyToCart = useFlyToCart();
  const { showToast } = useToast();
  const { openCartDrawer } = useCartCount();
  const { uid } = useAuth();

  const handleAddToCart = async (buttonRef, quantity = 1) => {
    if (!selectedProduct) {
      console.warn("Aucun produit sélectionné");
      return;
    }

    // Récupération du bouton panier dans le Header (via son ID)
    const panierButton = document.getElementById("panier-button");
    
    // Déclenchement de l'animation si les deux boutons sont trouvés
    if (buttonRef?.current && panierButton) {
      flyToCart(buttonRef.current, panierButton);
    }

    // Ajout du produit dans Firestore (l'animation se joue en parallèle)
    try {
      if (!uid) {
        showToast("Connexion en cours… Réessayez dans un instant.");
        return;
      }
      await addProductToPanier(selectedProduct, uid, quantity);
      console.log("Produit ajouté dans Firestore :", selectedProduct.name);
      showToast(quantity > 1 ? `${quantity} produits ajoutés au panier` : "Produit ajouté au panier");
      openCartDrawer();
    } catch (error) {
      console.error("Erreur lors de l'ajout dans Firestore :", error);
    }
  };

  const decrementFicheQuantity = () => {
    setFicheQuantity((prev) => Math.max(1, prev - 1));
  };

  const incrementFicheQuantity = () => {
    setFicheQuantity((prev) => Math.min(99, prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  /**
   * Section order-section : inscription newsletter (Firestore + Brevo), sans ajout au panier.
   */
  const handleOrder = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (!email || !email.trim()) {
      setError("Veuillez renseigner votre email");
      return;
    }

    try {
      if (!uid) {
        setError("Connexion en cours… Réessayez dans un instant.");
        return;
      }

      await addDoc(collection(db, "newsletter"), {
        email: email.trim(),
        createdAt: serverTimestamp(),
        source: "dinoledinosaure-order",
      });

      try {
        await addEmailToBrevo(email.trim());
      } catch (brevoError) {
        console.warn("Erreur Brevo (non bloquant) :", brevoError);
      }

      setSuccess("Merci ! Votre inscription a bien été enregistrée.");
      showToast("Merci ! Votre inscription a bien été enregistrée.");
      setEmail("");
    } catch (err) {
      console.error("Erreur lors de l'inscription :", err);
      setError("Une erreur est survenue. Veuillez réessayer.");
    }
  };

  return (
    <>
      <div className="dino-page">
        <ProductComponent
          slug="dinoledinosaure"
          onProductReady={(product) => setSelectedProduct(product)}
        />
        <div className="hero-section">
          <img src={FirstDino} alt="Veilleuse Dino le dinosaure" className="hero-img" />
          <div className="hero-content">
            <h1 className="hero-title">Dino le dinosaure</h1>
            <button 
              type="button" 
              className="hero-button-dino" 
              ref={heroButtonRef}
              onClick={() => handleAddToCart(heroButtonRef)}
            >
              Commander
            </button>
          </div>
        </div>

        <section className="dino-product-fiche" aria-labelledby="dino-fiche-title">
          <div className="dino-product-fiche__inner">
            <div className="dino-product-fiche__media">
              <img
                src={imgFicheDino}
                alt="Veilleuse Dino le dinosaure, silhouette sur fond transparent"
                className="dino-product-fiche__img"
                width={600}
                height={600}
                loading="lazy"
              />
            </div>
            <div className="dino-product-fiche__card">
              <h2 id="dino-fiche-title" className="dino-product-fiche__title">
                <strong className="confdino">Dino le dinosaure</strong>
              </h2>

              <p className="dino-product-fiche__price" aria-label="Prix">
                {selectedProduct != null
                  ? `${String(selectedProduct.price.toFixed(2)).replace(".", ",")} €`
                  : "21,90 €"}
              </p>

              <div className="dino-product-fiche__actions">
                <div className="dino-product-fiche__qty" aria-label="Choix de la quantité">
                  <button type="button" onClick={decrementFicheQuantity} disabled={ficheQuantity <= 1}>-</button>
                  <span>{ficheQuantity}</span>
                  <button type="button" onClick={incrementFicheQuantity} disabled={ficheQuantity >= 99}>+</button>
                </div>
                <button
                  type="button"
                  className="dino-product-fiche__cta"
                  ref={ficheCtaRef}
                  onClick={() => handleAddToCart(ficheCtaRef, ficheQuantity)}
                >
                  AJOUTER AU PANIER
                </button>
              </div>

              <ul className="dino-product-fiche__shipping" aria-label="Informations livraison">
                <li>
                  <span className="dino-product-fiche__check" aria-hidden="true">
                    ✓
                  </span>
                  Livraison point relais gratuite (Chrono Shop2Shop)
                </li>
              </ul>

              <ul className="dino-product-fiche__infos">
                <li className="dino-product-fiche__stock-line">
                  <i className="bi bi-circle-fill" aria-hidden="true" /> En stock
                </li>
                <li><i className="bi bi-arrow-repeat" aria-hidden="true" /> LIVRAISON OFFERTE EN POINT RELAIS</li>
                <li><i className="bi bi-shield-lock" aria-hidden="true" /> Paiement sécurisé</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="dino-text-section">
          <section className="presentation-section-dino">
            <div className="image-logo-and-patte">
              <img src={oeufdino} alt="Icône" />
              <img src={vertynoLogo} alt="Logo Vertyno" className="vertyno-logo" />
            </div>
            <h2 className="presentation-title-dino">
              <strong className="confdino">Dino,</strong> le compagnon rassurant des petits aventuriers
            </h2>
            <article className="presentation-text-area-dino">
              <p className="presentation-text-dino">
                <strong className="confdino">Dino</strong>, le compagnon des nuits paisibles — une douceur signée VERTYNO.
                Avec son regard joueur et sa lumière rassurante, <strong className="confdino">Dino</strong> veille sur les tout-petits.
                Conçu en silicone moelleux sans BPA, il est aussi doux à câliner qu’agréable à regarder. D’un simple tapotement,
                il diffuse une lueur réconfortante pour apaiser les nuits. Une bulle de douceur, signée VERTYNO.
              </p>
              <img src={dinoBack} alt="Dino le dinosaure lumineux" className="dino-doudou-img" />
            </article>
          </section>
        </section>

        <section className="double-image-section-dino">
          <div className="double-image-content-dino">
            <img src={dinoOne} alt="image_de_la_veilleuse_dino" className="widthimage" />
            <img src={dinoTwo} alt="image_de_la_veilleuse_dino" className="widthimage" />
          </div>
        </section>

        <section className="advantages-and-order-dino">
          <div className="advantages-section">
            <h2 className="confiteria advantages-title">Dino le dinosaure</h2>
            <div className="advantages-list">
              {["Sécurité", "Qualité", "Éco-responsable"].map((titre, index) => (
                <div className="advantage-item" key={index}>
                  <div className={`advantage-bar ${activeIndex === index ? "active" : ""}`}></div>
                  <h3>{titre}</h3>
                  <p>
                    {index === 0 && "Silicone alimentaire sans BPA et LED sans danger pour les yeux."}
                    {index === 1 && "Doux, résistant et lumière apaisante pour un sommeil serein."}
                    {index === 2 && "Rechargeable, et fait pour durer."}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="order-section">
            <div className="order-content-dino">
           <h3>Rejoignez notre bulle de douceur</h3> 
              <p>
                Laissez <strong className="confdino">Dino</strong> veiller sur les nuits de votre enfant avec tendresse. Inscrivez-vous pour faire partie de la famille Vertyno : recevez nos inspirations pour des couchers apaisés, découvrez nos nouveautés en avant-première et profitez de petites attentions exclusives, imaginées juste pour vous.
              </p>
              <form onSubmit={handleOrder}>
                <label htmlFor="email">Adresse email :</label>
                <input
                  type="email"
                  id="email"
                  placeholder="saisir"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">Rejoignez-nous</button>
                {error && <p className="erreur-message">{error}</p>}
                {success && <p className="success-message">{success}</p>}
              </form>
            </div>
            <img src={dinoGround} alt="Veilleuse Dino" className="order-image" />
          </div>
        </section>

        <section className="dinoimageandtext">
          <img src={dinoThree} alt="image_des_caracteristiques_de_dino" className="widthimage" />
        </section>

        <section className="dino-magie-text">
          <h2><span className="confiteria">Dino</span>, le gardien bienveillant des nuits</h2>
          <p>
            Conçu pour le bien-être des enfants, <span className="confiteria">Dino</span> allie confort et sécurité.
            Son silicone moelleux sans BPA est adapté aux petites mains, tandis que sa lumière LED douce protège les yeux sensibles.
            Avec ses 7 couleurs changeantes, il s’adapte à chaque moment : une lueur apaisante pour l’endormissement,
            un éclairage rassurant pour la nuit, ou une touche de magie pour les rêves éveillés.
            Une veilleuse maligne, une magie VERTYNO.
          </p>
        </section>

        <section className="dino-section-quatreimg">
          <img src={dinoQuatre} alt="image_de_couleurs_de_dino" className="widthimage dispFlex" />
        </section>

        <section className="dino-caracteristiques">
          <h2>Caractéristiques de <span className="confiteria">Dino le dinosaure</span></h2>
          <div className="caracteristiques-grid">
            <div className="carac-item">Niveaux d’intensité<br /><strong className="reglage">Réglable,<br /> BLANCHE</strong></div>
            <div className="carac-item">Autonomie<br /><strong className="reglage">Jusqu’à une nuit <br /> de sommeil</strong></div>
            <div className="carac-item">Capacité<br /><strong className="reglage">1200 mAH</strong></div>
            <div className="caracteristiques-divider"></div>
            <div className="carac-item">Mode lumineux<br /><strong className="reglage">7 couleurs<br /> changeantes</strong></div>
            <div className="carac-item">Lumière<br /><strong className="reglage">Douce à 360°</strong></div>
            <div className="carac-item">Contrôle<br /><strong className="reglage">Par tapotement</strong></div>
            <div className="caracteristiques-divider"></div>
            <div className="carac-item">Minuterie<br /><strong className="reglage">30 minutes</strong></div>
            <div className="carac-item">Batterie<br /><strong className="reglage">Rechargeable <br />via USB</strong> <small>(câble inclus)</small></div>
            <div className="carac-item">Sécurité<br /><strong className="reglage">Sans BPA, en silicone alimentaire, sans danger pour les yeux</strong></div>
            <div className="caracteristiques-divider"></div>
            <div className="carac-item unique">Matière<br /><strong className="reglage">Silicone doux <br />et moelleux</strong></div>
          </div>

          <div className="guide-utilisation">
            <h3>Guide d’utilisation</h3>
            <p>
              Appuyez légèrement sur <strong className="confdino">Dino</strong> pour l’allumer ou varier l’intensité.
              Son mode multicolore ajoute une touche de magie avant le coucher.
              Tapotez au moment où la couleur préférée apparaît pour la figer.
              Activez le minuteur pour qu’il s’éteigne automatiquement,
              et laissez <strong className="confdino">Dino</strong> veiller toute la nuit sur votre enfant.
            </p>
          </div>
        </section>

        <section className="dino-packaging">
          <img src={dinoFive} alt="Boîte Dino le dinosaure" className="packaging-box-img widthimage" />
          <div className="packaging-btns">
            <button
              className="white-outline-btn"
              type="button"
              ref={packagingButtonRef}
              onClick={() => handleAddToCart(packagingButtonRef)}
            >
              Commander
            </button>
            <button className="white-outline-btn"><a href={"/Contact"}>Contact</a></button>
          </div>
        </section>
      </div>
    </>
  );
}
